/**
 * @fileoverview Constants for data layer field configuration including
 * column widths and API timeout values.
 */

/**
 * Field widths by size category (in pixels).
 * Use these for general-purpose column sizing.
 */
export const FIELD_WIDTHS = {
  TINY: 80,
  SMALL: 100,
  MEDIUM: 150,
  LARGE: 200,
  XLARGE: 300,
} as const;

/**
 * Field widths by semantic field type (in pixels).
 * Use these for specific data types with known display requirements.
 */
export const FIELD_TYPE_WIDTHS = {
  ID: 90,
  NAME: 125,
  EMAIL: 150,
  PHONE: 110,
  DATE: 150,
} as const;

/** Timeout values in milliseconds */
export const TIMEOUT_MS = {
  /** Default timeout for session auth initialization */
  AUTH_INIT: 6000,
} as const;

/** Time offset values in milliseconds */
export const TIME_OFFSET_MS = {
  /** 2 hours offset for date normalization (used in API date handling) */
  TWO_HOURS: 2 * 60 * 60 * 1000,
} as const;
